import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
    auth: {
      clientId: "5a1bf12f-2d04-4e95-badc-ac1005f4f740",
      authority: "https://login.microsoftonline.com/ITNltd.onmicrosoft.com/",
      redirectUri: process.env.REACT_APP_AZUREAD_REPLY_URL
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };

export const app = new PublicClientApplication(msalConfig);

export const login = {
  scopes: [ "api://5a1bf12f-2d04-4e95-badc-ac1005f4f740/Roster.Read" ],
  extraScopesToConsent: ['https://graph.microsoft.com/User.ReadBasic.All', 'https://graph.microsoft.com/User.Read']
 };